export const state = {
  IS_COLLECTION: 'isCollection',
  DATASET: 'dataset',
  COLLECTION: 'collection',
  SUBJECTS: 'subjects',
  VARIABLES: 'variables',
  SUBJECT_VARIABLES: 'subjectVariables',
  OBSERVATION_VARIABLES: 'observationVariables',
  SELECTED_VARIABLES: 'selectedVariables',
  VARIABLE_DATA: 'variableData',
  FIRST_VISITS: 'firstVisits',
  LAST_VISITS: 'lastVisits',
  VISIT_VARIABLE: 'visitVariable',
  VISIT_SUMMARIES: 'visitSummaries',
  TIMES_BETWEEN_VISITS: 'timesBetweenVisits',
  TIMES_BETWEEN_VISITS_REQUEST_NUM: 'timesBetweenVisitsRequestNum',
  TIMES_BETWEEN_VISITS_REQUEST_DELAY_SECS: 'timesBetweenVisitsRequestDelaySecs',
  NUM_SELECTED_SUBJECTS: 'numSelectedSubjects',
  USE_LONG_SCALE_NAMES: 'useLongScaleNames',
  ENABLE_VARIABLE_SELECTION: 'enableVariableSelection',
};

export const getters = {};

export const mutations = {
  SET_IS_COLLECTION: 'setIsCollection',
  SET_DATASET: 'setDataset',
  SET_COLLECTION: 'setCollection',
  SET_SUBJECTS: 'setSubjects',
  SET_VARIABLES: 'setVariables',
  SET_SUBJECT_VARIABLES: 'setSubjectVariables',
  SET_OBSERVATION_VARIABLES: 'setObservationVariables',
  SET_SELECTED_VARIABLES: 'setSelectedVariables',
  SET_VARIABLE_DATA: 'setVariableData',
  SET_USE_LONG_SCALE_NAMES: 'setUseLongScaleNames',
  SET_ENABLE_VARIABLE_SELECTION: 'setEnableVariableSelection',
  SET_VISIT_VARIABLE: 'setVisitVariable',
  SET_FIRST_VISITS: 'setFirstVisits',
  SET_LAST_VISITS: 'setLastVisits',
  SET_VISIT_SUMMARIES: 'setVisitSummaries',
  SET_TIMES_BETWEEN_VISITS: 'setTimesBetweenVisits',
  INCREMENT_TIMES_BETWEEN_VISITS_REQUEST_NUM:
    'incrementTimesBetweenVisitsRequestNum',
  RESET_TIMES_BETWEEN_VISITS_REQUEST_NUM: 'resetTimesBetweenVisitsRequestNum',
  SET_NUM_SELECTED_SUBJECTS: 'setNumSelectedSubjects',
};

export const actions = {
  FETCH_DATASET: 'fetchDataset',
  FETCH_COLLECTION: 'fetchCollection',
  FETCH_SUBJECTS: 'fetchSubjects',
  SET_IS_COLLECTION: 'setIsCollection',
  SET_USE_LONG_SCALE_NAMES: 'setUseLongScaleNames',
  SET_ENABLE_VARIABLE_SELECTION: 'setEnableVariableSelection',
  GET_VARIABLE_COUNTS: 'getVariableCounts',
  SET_VISIT_VARIABLE: 'setVisitVariable',
  SET_FIRST_VISITS: 'setFirstVisits',
  SET_LAST_VISITS: 'setLastVisits',
  SET_FIRST_VISIT: 'setFirstVisit',
  SET_LAST_VISIT: 'setLastVisit',
  SET_SELECTED_VARIABLES: 'setSelectedVariables',
  FETCH_VISIT_SUMMARIES: 'fetchVisitSummaries',
  FETCH_TIMES_BETWEEN_VISITS: 'fetchTimesBetweenVisits',
  GET_STUDY_SUBJECT_VARIABLE_VISITS: 'fetchStudySubjectVariableVisits',
  RESET_ALL: 'resetAll',
};
